import { useState, useEffect, useCallback } from "react";
import { useAuth } from "../useAuth/useAuth";

/**
 * Retrieves and stores Tripla One-Time Token (OTT) for authenticated users.
 * Returns the fetched `oneTimeToken`.
 */
export function useTriplaOTT() {
  const [oneTimeToken, setOneTimeToken] = useState<string | null>(null);
  const { userStore: user } = useAuth();

  // Fetches Tripla one-time token for the authenticated user
  const fetchTriplaToken = useCallback(async () => {
    if (!user) {
      return null;
    }
    return "";
  }, [user]);
  useEffect(() => {
    // Initialize token when user is available
    const initializeToken = async () => {
      if (user) {
        const token = await fetchTriplaToken();
        if (token) {
          setOneTimeToken(token);
        }
      }
    };
    initializeToken();
  }, [user, setOneTimeToken, fetchTriplaToken]);

  return { oneTimeToken };
}
